module.exports = __webpack_public_path__ + "static/instaIcon-10f707a8cd6c7a5be991bb38def97675.svg";